const o = (e) => new Promise((t) => setTimeout(t, e * 1e3));
export {
  o as Wait
};
//# sourceMappingURL=index37.js.map
